module.exports = __webpack_require__.p + "48a59bb5e9a39daec60b2f790e3f6df9.jpg";